import { EN_STRING_OVERRIDES } from '@web-config-app/common';
import { nodesConfig } from '@web-config-app/masonry-nodes';
import { alertBannerConfig } from '@web-config-app/alert-banner';

export const EN_CONFIG_APP_STRINGS = {
  ...EN_STRING_OVERRIDES,
  ...nodesConfig?.strings?.en,
  ...alertBannerConfig?.strings?.en,
};
